var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "add-item-to-basket-overlay-matrix" } }, [
    _c("div", { staticClass: "modal fade" }, [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _vm.basketItems
            ? _c(
                "div",
                { staticClass: "modal-content" },
                [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("div", { staticClass: "modal-title h5" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.singleItemAdded")
                          ) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close ml-0 pl-1",
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          "aria-label": _vm.$translate(
                            "Ceres::Template.closeIcon"
                          )
                        }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      { staticClass: "row is-table-row" },
                      _vm._l(_vm.basketItems, function(basketItem, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "col-12 col-lg-6 mb-3" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-4",
                                  staticStyle: { "min-height": "80px" }
                                },
                                [
                                  _c("lazy-img", {
                                    style: { maxHeight: "140px" },
                                    attrs: {
                                      "image-url": _vm.imageUrl,
                                      alt:
                                        _vm.imageAlternativeText ||
                                        _vm.itemName,
                                      title: _vm.itemName,
                                      "picture-class": "img-fluid mx-auto"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-8" },
                                [
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.itemName(basketItem)))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "small" }, [
                                    _c("strong", [
                                      _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(basketItem.quantity) + " x "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.getPrice(basketItem)
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    basketItem.variation.data.attributes,
                                    function(attribute, index) {
                                      return _c(
                                        "p",
                                        { key: index, staticClass: "small" },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                attribute.attribute.names.name
                                              )
                                            )
                                          ]),
                                          _vm._v(":\n                    "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(attribute.value.names.name)
                                            )
                                          ])
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    basketItem.variation.data.properties,
                                    function(property) {
                                      return _c(
                                        "p",
                                        {
                                          key: property.property.id,
                                          staticClass: "small"
                                        },
                                        [
                                          _vm.orderParamValue(
                                            property.property.id
                                          )
                                            ? [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.orderParamName(
                                                        basketItem,
                                                        property.property.id
                                                      )
                                                    ) +
                                                      " (+ " +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          _vm._f(
                                                            "propertySurcharge"
                                                          )(
                                                            basketItem.variation
                                                              .data.properties,
                                                            property.property.id
                                                          )
                                                        )
                                                      ) +
                                                      ")"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                property.property.valueType ===
                                                "file"
                                                  ? _c("span", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: _vm._f(
                                                              "fileUploadPath"
                                                            )(
                                                              _vm.orderParamValue(
                                                                basketItem,
                                                                property
                                                                  .property.id
                                                              )
                                                            ),
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-external-link",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          }),
                                                          _vm._v(
                                                            "\n                          : " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "fileName"
                                                                )(
                                                                  _vm.orderParamValue(
                                                                    basketItem,
                                                                    property
                                                                      .property
                                                                      .id
                                                                  )
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  : property.property
                                                      .valueType !== "empty"
                                                  ? _c("span", [
                                                      _c("b", [_vm._v(": ")]),
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.orderParamValue(
                                                            basketItem,
                                                            property.property.id
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "waiting-animation-infinite",
                            rawName: "v-waiting-animation-infinite"
                          }
                        ],
                        staticClass: "btn btn-outline-primary btn-medium mr-2",
                        attrs: { href: _vm.urls.basket, rel: "nofollow" }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-shopping-cart",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.singleItemBasket")
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "waiting-animation-infinite",
                            rawName: "v-waiting-animation-infinite"
                          }
                        ],
                        staticClass: "btn btn-primary btn-medium",
                        attrs: { href: _vm.urls.checkout, rel: "nofollow" }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-arrow-right",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.singleItemCheckout"
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._t("extendOverlayButtons")
                ],
                2
              )
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-muted ml-auto" }, [
      _c("span", { staticClass: "timer" }),
      _vm._v("s")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }